import './App.css';
import React from "react";
import MainInterface from "./mainInterface.tsx";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {

  return (
      <div className="App pagefill">
        <MainInterface/>
      </div>
  );
}

export default App;
